import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { AiOutlineShopping, AiOutlineArrowLeft } from 'react-icons/ai';
import { GoHome } from 'react-icons/go';
import { FiShare2 } from "react-icons/fi"
import { client } from '../sanity/sanityClient';
import { useStateContext } from '../context/StateContext';
import Cart from './Cart';
import ShopDesktop from "./ShopDesktop";
import ProductMerchantDisplay from "./ProductMerchantDisplay";
import './Productsshop.css';

const Shop = () => {
  const { contactId } = useParams(); // ✅ from route
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const { totalQuantities, showCart, setShowCart } = useStateContext();

  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 768px)").matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    const handleChange = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  const getCurrency = () => localStorage.getItem('selectedCurrency') || 'TZS';

  // ✅ FETCH PRODUCTS BY USER (CONTACT)
  const fetchSellerProducts = useCallback(async () => {
    try {
      setLoading(true);
      const currency = getCurrency();

      const data = await client.fetch(
        `*[_type in [
          "grocery","beauty","hotels","estate","clothingandfashion","servicesandinstitutions",
          "kitchen","crops","electronics","jewelryandaccessories","eventsandnightclubs",
          "salon","foodandbeverages","sports","arts","medical","agritech","giftoptions",
          "vehicles","livestock","hardware","useditems","construction","cuisines",
          "booksandstationery","kidsandtoys","hospitality","homeandfurnitures",
          "fashion","energyandfuel"
        ] && user == $contactId && currency == $currency]`,
        { contactId, currency }
      );

      setProducts(
        data.map((product) => ({
          ...product,
          currentImageIndex: 0,
          quantity: 1,
        }))
      );
    } catch (error) {
      console.error("Error fetching seller products:", error);
    } finally {
      setLoading(false);
    }
  }, [contactId]);

  useEffect(() => {
    fetchSellerProducts();

    const handleStorageChange = (e) => {
      if (e.key === 'selectedCurrency') {
        fetchSellerProducts();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [fetchSellerProducts]);

  const handleBackNavigation = () => {
    navigate(-1);
  };

  return (
    <div className="shop-page-container">

      {/* 🔝 TOP BAR */}
      <div className="NavPan" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        padding: '10px 20px',
        background: '#ffffff',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <button
          onClick={handleBackNavigation}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}
        >
          <AiOutlineArrowLeft /> Back
        </button>
        <h3><Link 
            to={'/'} 
            style={{ color: 'black', display:'flex', fontSize: '16px', fontFamily:'inherit', alignItems:'center', height: '20px', marginLeft: '1.5%', textDecoration: 'none' }}
          >
            <GoHome />Home
          </Link></h3>
            <button
    onClick={() => {
      const shareUrl = `${window.location.origin}/#/shop/${contactId}`;

      if (navigator.share) {
        navigator.share({
          title: "Visit My Store",
          text: "Check out this store",
          url: shareUrl
        });
      } else {
        navigator.clipboard.writeText(shareUrl);
        alert("Store link copied!");
      }
    }}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      background: 'transparent',
      border: 'none',
      color: '#111',
      padding: '8px 14px',
      borderRadius: '20px',
      cursor: 'pointer',
      fontSize: '13px',
      fontWeight: '500'
    }}
  >
    <FiShare2 size={16} />
  </button>
        <button
          onClick={() => setShowCart(true)}
          style={{
            background: 'transparent',
            border: 'none',
            fontSize: '1.5rem',
            position: 'relative',
            cursor: 'pointer'
          }}
        >
          <AiOutlineShopping />
          <span className="cart-item-qty">{totalQuantities}</span>
        </button>

        <div className={`modal ${showCart ? 'active' : ''}`}>
          <Cart />
        </div>
      </div>

      {/* 🛍 PRODUCTS */}
      <div className="shop-content" style={{
        marginTop: '70px',
        padding: isMobile ? '1px' : '20px 60px'
      }}>

        {loading ? (
          <p style={{
              textAlign: 'center',
              padding: '20px',
              fontSize: '16px',
              color: '#555',
            }}>Loading products...</p>
        ) : products.length === 0 ? (
          <p style={{
              textAlign: 'center',
              padding: '20px',
              fontSize: '16px',
              color: '#555',
            }}>No products found for this user.</p>
        ) : (
          <div className={isMobile ? "mobile-grid" : "desktop-grid"}>
            {isMobile ? (
              <ProductMerchantDisplay products={products} />
            ) : (
              products.map((product) => (
                <ShopDesktop key={product._id} product={product} />
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Shop;